import { AlertPosition, AlertDuration } from './constant.shared';

export function createAlertConfig(message: string, success: boolean, duration: number = AlertDuration) : any {
  return {
    message: message,
    color: success ? 'is-success' : 'is-danger',
    position: AlertPosition,
    duration: duration
  };
}
